import { useMemo } from "react";
import {
  Box,
  Text,
  CircularProgress,
  Container,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  Grid,
  HStack,
  Stack,
  IconButton,
  VStack,
  // List,
  // Divider,
} from "@chakra-ui/react";
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import { ChevronRightIcon, CopyIcon } from "@chakra-ui/icons";

import { useParams, useHistory } from "react-router-dom";

import toUpper from "lodash/toUpper";
// import toLower from "lodash/toLower";
import { format, parseISO } from "date-fns";
import formatter from "util/formatter";
import { floatString } from "util/utils";

import { useGetCompletedTradeByIdQuery } from "services/p2pApi";

// import StarBorderIcon from "@material-ui/icons/Star";
// import Rating from "@material-ui/lab/Rating";
// import { ReactComponent as FileIcon } from "assets/svg/fileIcon.svg";
import Button from "components/Button/Button";
import useCopy from "hooks/useCopy";
// import DetailItem from "components/DetailItem/DetailItem";
import capitalize from "lodash/capitalize";
import UserPopover from "components/UserPopover/UserPopover";
import toPrecision from "util/toPrecision";

const transformCompletedTradesData = (data) => ({
  ...data,
  adsType: data?.counterParty?.role === "buyer" ? "buying" : "selling",
  fiat:
    data?.originalParty?.role === "seller"
      ? data?.destinationUnit
      : data?.sourceUnit,
  token: data?.originalParty?.role === "seller" ? data?.sourceUnit : data?.coin,
  amount: data?.currencyValue,
  contractState: "closed",
});

const TraderSessionCompleted = ({
  trade,
  trader,
  tradeId,
  frozenRef,
  userData,
}) => {
  const history = useHistory();

  console.log("trade", trade);

  const parties = useMemo(() => {
    const arr = [
      {
        ...(trade?.counterParty ?? {}),
        rank: trade?.counterParty?.userId === userData?._id ? 2 : 1,
      },
      {
        ...(trade?.originalParty ?? {}),
        rank: trade?.originalParty?.userId === userData?._id ? 2 : 1,
      },
    ].sort((a, b) => b?.rank - a?.rank);

    return arr;
  }, [trade, userData]);

  console.log("PARTIES", parties, userData);

  // const [_rateTrade, { isLoading: isRating }] = useRateTradeMutation();

  // const rate = trade?.ratings?.find(
  //   (rate) => rate?.userId === userData?.userId
  // );

  // const proofOfWaiverFileName = useMemo(() => {
  //   const tokens = String(trader?.proofOfWaiver).split("/");
  //   return tokens[tokens?.length - 1];
  // }, [trader]);

  // console.log("proof name", proofOfWaiverFileName);

  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Completed</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            Your order has been completed.
          </Text>
        </HStack>
      </Box>

      <Stack p="20px 0" maxW="100px">
        <Button
          onClick={() => history.replace("/dashboard/wallet")}
          bg="transparent"
          minW="80px !important"
          fontSize="xs"
          fontWeight="400"
          color="#03A438"
          p="0 !important"
        >
          View wallet
        </Button>
      </Stack>

      <Stack borderTop="1px solid #D9DBE9" p="32px 0">
        <Text fontSize="16px" fontWeight="600">
          Trade Details
        </Text>

        <Stack gridGap="24px">
          <Grid templateRows="repeat(3, 1fr)" gap="12px">
            <Grid templateColumns="repeat(3, 1fr)">
              <Text>{""}</Text>
              {parties?.map((party, pidx) => {
                return (
                  <Text fontSize="14px" color="#4E4B66" fontWeight="400">
                    {capitalize(party?.role)}
                  </Text>
                );
              })}
            </Grid>

            <Grid templateColumns="repeat(3, 1fr)">
              <Text fontSize="14px" color="#4E4B66" fontWeight="400">
                Username
              </Text>
              {parties?.map((party, pidx) => {
                return <UserPopover key={`popover-${pidx}`} user={party} />;
              })}
            </Grid>

            <Grid templateColumns="repeat(3, 1fr)">
              <Text fontSize="14px" color="#4E4B66" fontWeight="400">
                Amount Paid
              </Text>
              {parties?.map((party, pidx) => {
                return (
                  <Text key={`amount-paid-${pidx}`}>
                    {party?.role === "seller"
                      ? toPrecision(trade?.coinValue, trade?.coin)
                      : formatter(trade?.currency).format(trade?.currencyValue)}
                  </Text>
                );
              })}
            </Grid>

            <Grid templateColumns="repeat(3, 1fr)">
              <Text fontSize="14px" color="#4E4B66" fontWeight="400">
                Amount Received
              </Text>
              {parties?.map((party, pidx) => {
                return (
                  <Text key={`amount-paid-${pidx}`}>
                    {party?.role === "buyer"
                      ? toPrecision(trade?.coinValue, trade?.coin)
                      : formatter(trade?.currency).format(trade?.currencyValue)}
                  </Text>
                );
              })}
            </Grid>

            {/* {parties?.map((party, pidx) => {
              const keys = Object.keys(omit(party, ["_id", "rank", "userId"]));

              return (
                <Grid templateColumns="repeat(3, 1fr)" gap="12px">
                  <Text>Username</Text>
                  <UserPopover user={party} />
                  <UserPopover user={party} />
                </Grid>
              );
            })} */}
          </Grid>
          {/* {parties?.map((party, pidx) => {
            const keys = Object.keys(omit(party, ["_id", "rank", "userId"]));

            console.log(keys);

            return (
              <Box minW="200px">
                <List>
                  {keys?.map((key, i) => (
                    <DetailItem
                      key={`detail-${i}`}
                      itemTitle={capitalize(key === "role" ? "title" : key)}
                      value={
                        key === "username" ? (
                          <UserPopover user={party} />
                        ) : (
                          capitalize(party[key])
                        )
                      }
                      bg="transparent"
                      px="0"
                      _title={{ color: pidx === 1 ? "transparent" : "#4E4B66" }}
                    />
                  ))}
                </List>
              </Box>
            );
          })} */}

          {/* <Divider orientation="vertical" />

          <Box minW="200px">
            <List>
              <DetailItem
                itemTitle="Trader Action"
                value="Buyer"
                bg="transparent"
                px="0"
              />
            </List>
          </Box> */}
        </Stack>
      </Stack>
    </>
  );
};

const CompletedTrade = (props) => {
  const { userData } = props;
  const { id } = useParams();
  const { onCopy } = useCopy();

  const { data: raw, isLoading } = useGetCompletedTradeByIdQuery(id);

  const data = useMemo(
    () => transformCompletedTradesData(raw?.tradeRecord),
    [raw]
  );

  const tradeType = useMemo(() => {
    const map = { selling: "Buy", buying: "Sell" };
    return map[data?.adsType];
  }, [data]);

  console.log("TRADE", raw);

  return (
    <Box
      __css={{
        "--color": "#4E4B66",
        "--borderColor": "#D9DBE9",
        "--focusColor": "#06c34491",
        "--primary": "#03A438",
      }}
    >
      <Sidemenu currentPage="P2P" logoutUser={props.logout} />
      <Header />

      <Box className="p2p">
        <Box
          className="p2p-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          {isLoading && (
            <Container maxW={["100%", "container.xl"]} p={["0", "0", "1rem"]}>
              <CircularProgress isIndeterminate size="20px" color="green" />
            </Container>
          )}

          {!isLoading && (
            <Container maxW={["100%", "container.xl"]} p={["0", "0", "1rem"]}>
              <Box px={["24px", "0", "0"]}>
                <Heading fontSize="3xl">
                  {tradeType} {toUpper(data?.token ?? "")}
                </Heading>

                <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                  <BreadcrumbItem>
                    <BreadcrumbLink to="/dashboard/p2p">P2P</BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <BreadcrumbLink to="/dashboard/p2p/trades">
                      Trade History
                    </BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink isCurrentPage href="#">
                      Completed Order
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Box>

              {data && (
                <Grid
                  templateColumns={["1fr", "", ".55fr .4fr"]}
                  overflow="hidden"
                  mt={["24px", "48px"]}
                  gridGap="20px"
                >
                  <Box bg="white" borderRadius={[0, "16px"]} h="fit-content">
                    <HStack
                      alignItems="flex-start"
                      gridGap={["8px", "32px"]}
                      p={["20px 24px", "20px 32px"]}
                      borderBottom="1px solid #D9DBE9"
                      flexDir={["column", "row"]}
                      pos="relative"
                    >
                      {/* <IconButton
                  d={["inline-flex", "inline-flex", "inline-flex", "none"]}
                  size="sm"
                  variant="ghost"
                  aria-label="copy"
                  icon={
                    <Box as={MessengerIcon} boxSize="18px" color="#6E7191" />
                  }
                  pos="absolute"
                  right={["24px", "24px", "32px", "0"]}
                  top={["unset", "10px", "50%", "50%"]}
                  bottom={["16px"]}
                  transform={["unset", "unset", "unset", "translateY(-50%)"]}
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                /> */}

                      <Stack
                        flexDir={["row", "column"]}
                        ml={["0 !important", "0.5rem"]}
                      >
                        <Text color="#4E4B66" fontSize="sm">
                          Date
                        </Text>
                        <Text
                          fontSize="sm"
                          mt="0px !important"
                          ml={["20px !important", "0 !important", "10px"]}
                        >
                          {/* 17-06-2021 */}

                          {data &&
                            format(parseISO(data?.createdAt), "dd-MM-yyy")}
                        </Text>
                      </Stack>
                      <Stack
                        flexDir={["row", "column"]}
                        ml={["0 !important", "0.5rem"]}
                      >
                        <Text color="#4E4B66" fontSize="sm">
                          Time
                        </Text>
                        <Text
                          fontSize="sm"
                          mt="0px !important"
                          ml={["20px !important", "0 !important", "10px"]}
                        >
                          {data && format(parseISO(data?.createdAt), "HH:mm")}
                        </Text>
                      </Stack>
                      <Stack
                        flexDir={["row", "column"]}
                        ml={["0 !important", "0.5rem"]}
                      >
                        <Text color="#4E4B66" fontSize="sm">
                          ID
                        </Text>
                        <HStack
                          mt={[
                            "-2px !important",
                            "0 !important",
                            "0px !important",
                          ]}
                          ml={["20px !important", "0 !important", "10px"]}
                        >
                          <Text fontSize="sm">{data?.id}</Text>
                          <IconButton
                            size="xs"
                            variant="ghost"
                            aria-label="copy"
                            icon={<CopyIcon />}
                            _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                            onClick={onCopy}
                          />
                        </HStack>
                      </Stack>
                    </HStack>

                    <Stack p={["24px", "32px"]}>
                      <HStack
                        alignItems="flex-start"
                        justifyContent="space-between"
                      >
                        <Stack>
                          <Text color="#4E4B66" fontSize="sm">
                            Amount
                          </Text>
                          <Text
                            fontSize="sm"
                            fontWeight="bold"
                            mt="0px !important"
                          >
                            {data && formatter(data?.fiat).format(data?.amount)}{" "}
                          </Text>
                        </Stack>
                        <Stack>
                          <Text color="#4E4B66" fontSize="sm">
                            Quantity
                          </Text>
                          <Text fontSize="sm" mt="0px !important">
                            {floatString(data?.volume)}{" "}
                            {toUpper(data?.token ?? "")}
                          </Text>
                        </Stack>
                        <Stack>
                          <Text color="#4E4B66" fontSize="sm">
                            Transaction Fee
                          </Text>
                          <Text mt="0px !important" fontSize="sm">
                            {floatString(data?.fee)}{" "}
                            {toUpper(data?.token ?? "")}
                          </Text>
                        </Stack>
                      </HStack>

                      {/* {mapStatusToComponent(
                      getStatus(appropriateSessionOwner?.role)
                    )} */}

                      <TraderSessionCompleted
                        trade={raw?.tradeRecord}
                        userData={userData}
                      />
                    </Stack>
                  </Box>
                </Grid>
              )}

              {!data && (
                <VStack>
                  <Text>No Data</Text>
                </VStack>
              )}
            </Container>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CompletedTrade;
